import { AxiosError } from "axios";

import type { ErrorHandler } from "./errorHandler.types";

interface LegalDocumentErrorData {
  pendingDocuments?: unknown[];
}

const LEGAL_DOCUMENT_EVENT = "legal-document-required";

export const legalDocumentHandler: ErrorHandler = (error: AxiosError) => {
  if (error.response?.status !== 451) return false;

  const data = error.response.data as LegalDocumentErrorData;
  const pendingDocuments = data?.pendingDocuments;

  if (!Array.isArray(pendingDocuments) || pendingDocuments.length === 0) {
    return false;
  }

  window.dispatchEvent(
    new CustomEvent(LEGAL_DOCUMENT_EVENT, {
      detail: { pendingDocuments },
    }),
  );

  return true;
};
